import { JSX } from "react";
import {
    CardWrapper,
    ProductBeverages,
    Tabs,
} from "@hatch-digital-nl/bravilor-storybook";
import { useProductSpecifications } from "../hooks/useProductSpecifications";
import { DstProductDetailViewModel } from "../interfaces/ProductDetailViewTypes";
import { DstProductDetailLabels } from "../utils/productDetailLabels";
import { ProductSpecificationTabId } from "../utils/productSpecificationsConstants";
import { ProductSpecificationsBodySkeleton } from "./specifications/ProductSpecificationsBodySkeleton";
import { ProductSpecificationsGrid } from "./specifications/ProductSpecificationsGrid";

interface Props {
    data?: DstProductDetailViewModel;
    labels: DstProductDetailLabels;
    loading: boolean;
}

export const ProductSpecifications = ({
    data,
    labels,
    loading,
}: Props): JSX.Element | null => {
    const {
        showSkeleton,
        showTabs,
        hasContent,
        tabs,
        cardTitle,
        specificationsLabel,
        activeTabId,
        setActiveTabId,
        specificationEntries,
        beveragesForDisplay,
        isBeveragesTabActive,
    } = useProductSpecifications({ data, labels, loading });

    if (!showSkeleton && !hasContent) {
        return null;
    }

    if (showSkeleton) {
        return (
            <CardWrapper isLoading>
                <ProductSpecificationsBodySkeleton />
            </CardWrapper>
        );
    }

    const bodyContent = isBeveragesTabActive ? (
        <ProductBeverages beverages={beveragesForDisplay} />
    ) : (
        <ProductSpecificationsGrid entries={specificationEntries} />
    );

    return (
        <CardWrapper
            title={showTabs ? cardTitle : specificationsLabel}
            titleAddon={
                showTabs ? (
                    <Tabs
                        tabs={tabs}
                        activeId={activeTabId}
                        onChange={(id: string) =>
                            setActiveTabId(id as ProductSpecificationTabId)
                        }
                    />
                ) : undefined
            }
            showHeaderDivider
        >
            {bodyContent}
        </CardWrapper>
    );
};
